import { useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import { logButtonClick } from '@/services/analytics.service';

export interface BackButtonProps {
  /**
   * Custom onClick handler. If not provided, defaults to navigate(-1)
   */
  onClick?: () => void;
  /**
   * Page name for analytics tracking
   */
  pageName?: string;
  /**
   * Button title/tooltip
   * @default "Back"
   */
  title?: string;
  /**
   * Variant style - "default" for regular pages, "board" for board pages with dark background
   * @default "default"
   */
  variant?: 'default' | 'board';
  /**
   * Additional CSS classes
   */
  className?: string;
}

export const BackButton: React.FC<BackButtonProps> = ({
  onClick,
  pageName,
  title = 'Back',
  variant = 'default',
  className = '',
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (pageName) {
      logButtonClick('Back', pageName);
    }
    if (onClick) {
      onClick();
    } else {
      navigate(-1);
    }
  };

  const baseClasses = 'p-3 transition-all rounded-xl';
  const variantClasses =
    variant === 'board'
      ? 'hover:bg-gray-100 dark:hover:bg-white/20'
      : 'hover:bg-gray-200 dark:hover:bg-white/10';

  return (
    <button
      onClick={handleClick}
      title={title}
      className={`back-button-component ${baseClasses} ${variantClasses} ${className}`}
    >
      <FiArrowLeft className="h-5 w-5 text-gray-700 dark:text-[#929bc9]" />
    </button>
  );
};

